import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "../router/router"; // Adjust the import path as necessary

export default function Layout() {
  return <RouterProvider router={router} />;
}
